import type { Database } from "@excel-center/supabase";
import { z } from "zod";

type DBCaseNoteType = Database["public"]["Enums"]["case_note_type"];

export const CaseNoteType = {
	GENERAL: "general",
	INCIDENT: "incident",
} as const satisfies Record<string, DBCaseNoteType>;

export type CaseNoteType = (typeof CaseNoteType)[keyof typeof CaseNoteType];

type _EnsureAllDBValues = Exclude<DBCaseNoteType, CaseNoteType> extends never ? true : never;
const _check: _EnsureAllDBValues = true;
void _check;

export const CASE_NOTE_TYPES = Object.values(CaseNoteType) as readonly CaseNoteType[];

export const caseNoteTypeSchema = z.enum(CaseNoteType);

export const CASE_NOTE_TYPE_LABELS: Record<CaseNoteType, string> = {
	general: "General",
	incident: "Incident",
};
